import { Component, Input } from '@angular/core';
import { RiskStatisticsAnalysisState } from '@types';
import { TranslateService } from '@shared/translate/translate.service';

@Component({
  selector: 'ft-efficiency-analysis',
  templateUrl: './efficiency-analysis.component.html',
  styleUrls: ['./efficiency-analysis.component.scss'],
})
export class EfficiencyAnalysisComponent {
  @Input() state: RiskStatisticsAnalysisState;
  tooltips: { [name: string]: string } = {};
  constructor(private translateService: TranslateService) {
    this.setTooltips();
  }

  private setTooltips() {
    this.tooltips[
      'products.efficiency-analysis-statistic-tooltip'
    ] = this.translateService.tooltip(
      'products.efficiency-analysis-statistic-tooltip'
    );
  }
}
